import axios from "axios";
import { Component } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import CommonToast from "./Toaster/CommonToast";
import CommonLoader from "./loaderComponent/CommonLoader";

export default class UOMAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      hsnCode: "",
      errors: {},
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      loading: true,
      color: '',
      uomData: props.location?.state?.data
    };
  }

  componentDidMount() {
    const { uomData } = this.state || {};
    if (uomData) {
      this.setState({
        name: uomData.name,
      })
      setTimeout(() => {
        this.setState({ loading: false, });
      }, 500);
    } else {
      setTimeout(() => {
        this.setState({ loading: false, });
      }, 500);
    }
  }


  handleChange = (event) => {
    const { name, value } = event.target;
    let errors = { ...this.state.errors };
    if (value.trim()) {
      delete errors[name];
    }
    this.setState({ [name]: value, errors });
  };

  validateForm = () => {
    const errors = {};
    const name = this.state.name.trim();
    if (!name) {
      errors.name = "Name is required";
    }
    // else if (!/^[A-Za-z\s]+$/.test(name)) {
    //   errors.name = "Name must contain only letters and spaces";
    // } 
    else if (name.length < 1) {
      errors.name = "Name must be at least 1 characters";
    }
    else if (name.length > 30) {
      errors.name = "Name must not exceed 30 characters";
    }
    return errors;
  };


  onSubmit = async (e) => {
    // debugger;
    e.preventDefault();
    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }
    this.setState({ loading: true });
    const { uomData } = this.state || {};
    try {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const payload = {
        name: this.state.name,
      };
      let uomStatusResponse;
      if (uomData && uomData.id) {
        uomStatusResponse = await axios.put(`/uoms/${uomData.id}`, payload, { headers });
      } else {
        uomStatusResponse = await axios.post('/uoms', payload, { headers });
      }
      this.setState({
        name: "",
        hsnCode: "",
        errors: {},
        showToast: true,
        toastMessage: uomStatusResponse.data.message ? uomStatusResponse.data.message : "UOM created successfully!",
        toastVariant: "success",
        color: 'green',

      },
        () => {
          setTimeout(() => {
            this.props.history.push('/uomlist');
            this.setState({ loading: false });
          }, 600);
        });

    } catch (error) {
      this.setState({
        showToast: true,
        toastMessage: error.response?.data?.message || "Error adding UOM",
        toastVariant: "danger",
        color: 'red',
        loading: false,
      });
    }
  };

  handleBack = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/UOMList");
      this.setState({ loading: false });
    }, 500);
  }

  render() {
    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={this.state.loading}>
          <Container className="pt-4">
            <Card className="shadow-sm rounded border-0">
              <Card.Header className="text-white">
                <strong>{this.state.uomData?.id ? "Update UOM" : "Add UOM"}</strong>
              </Card.Header>
              <Card.Body>
                {/* <Card.Text className="mb-3 text-muted">
                  Please enter the details of the Unit of Measurement.
                </Card.Text> */}
                <Form onSubmit={this.onSubmit}>
                  <Row className="mb-3">
                    <Col xs={12} md={6} lg={4}>
                      <Form.Group controlId="formName">
                        <Form.Label className="required">Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter UOM name"
                          name="name"
                          value={this.state.name}
                          onChange={this.handleChange}
                          isInvalid={!!this.state.errors.name}
                        />
                        <Form.Control.Feedback type="invalid">
                          {this.state.errors.name}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <div className="d-flex gap-2 mt-3">
                    <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" type="submit">
                      {this.state.uomData?.id ? 'Update' : 'Add'}
                    </Button>
                    <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel " onClick={this.handleBack}>
                      Cancel
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Container>
        </CommonLoader>
      </>

    );
  }
}
